.biel-header {
  align-items: top;
  display: flex;
  color: var(--biel-header-text-color);
  justify-content: space-between;
}


.biel-header__title {
  font-size: var(--biel-header-font-size);
  font-weight: var(--biel-header-font-weight);
}

.biel-header__powered-by:not(:empty) {
  color: var(--biel-header-powered-by-text-color);
  padding-top: 5px;
  font-size: 14px;
  height: 12px;
}

.biel-header__powered-by a {
  color: var(--biel-header-powered-by-link-color);
  font-weight: 500;
  text-decoration: none;
}

.biel-header__icons {
  display: flex;
  justify-content: flex-end;
}

.biel-header__icon {
  color: var(--biel-header-text-color);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 3px;
  padding-top: 0;
  margin-left: 5px;
}
